import { ConvertType, useFormatNumber } from '../../../hooks/useFormatNumber';
import { Input, InputProps } from '.';
import { memo } from 'react';

interface InputWithUnitProps extends InputProps {
  unit?: ConvertType;
  unitString?: string | React.ReactNode;
}

const InputWithUnit_: React.FC<InputWithUnitProps> = ({ unit, unitString, ...props }) => {
  const { unitChar } = useFormatNumber();
  return (
    <div className="flex items-end space-x-1 text-lg">
      <div className="w-32">
        <Input {...props} />
      </div>
      <div className="pb-[7px] text-lg">{unit ? unitChar(unit) : unitString}</div>
    </div>
  );
};

export const InputWithUnit = memo(InputWithUnit_) as typeof InputWithUnit_;
